module.exports = __webpack_public_path__ + "img/question.2a5474a9.png";